<template>
  <grid ref="grid" :config="gridConfig" class="no-grid-border" />
</template>

<script>
import gridConfig from './GridConfig'
import { waitValue } from '@/utils/promises'

export default {
  name: 'Index',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  props: {
    rfqid: { required: true },
    po: { required: true }
  },
  watch: {
    rfqid: 'loadData'
  },
  created () {
    this.$bus.$on('on-click-tab-related-po-wo', this.loadData)
  },
  beforeDestroy () {
    this.$bus.$off('on-click-tab-related-po-wo', this.loadData)
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  computed: {
    defaultData () {
      return {
        po: this.po,
        rfqid: this.rfqid
      }
    }
  },
  methods: {
    loadData () {
      this.getGrid()
        .then((grid) => {
          if (!this.rfqid) {
            return grid.resetData()
          }
          grid.setFilters(`rfq.rfqid == "${this.rfqid}" `)
          grid.loadData()
        })
    },
    getGrid () {
      return waitValue(() => this.$refs.grid)
    }
  }
}
</script>
